import { apiClient } from "../api/client";

// Requests of the organisation's hiring page that api/jobs.js does not
// make. Each rejects with the server's message (see api/client.js).

/**
 * The applications to the organisation's jobs, without the CV and resume
 * contents (up to 5 MB each): enough to tell who applied to which job.
 */
export async function fetchHRApplicantSummariesApi() {
  const res = await apiClient.get("/jobs/hr/applicants", {
    params: { files: "none" },
  });
  return res.data;
}
